import { render, staticRenderFns } from "./SalutationSelect.vue?vue&type=template&id=031dea2d"
import script from "./SalutationSelect.vue?vue&type=script&lang=js"
export * from "./SalutationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports